import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  createUserService,
  getEscuelasSelectorService,
  getPlantelesByEscuelaService,
  getUserByIdService,
  getUsersService,
  toggleUserActiveService,
  updateUserService,
} from "../../../services/users/users.service";

export const getUsersThunk = createAsyncThunk(
  "users/getAll",
  async (
    { page = 1, search = "", escuela = null, plantel = null } = {},
    { rejectWithValue },
  ) => {
    try {
      return await getUsersService(page, search, escuela, plantel);
    } catch (error) {
      if (error.response?.status === 404) {
        return rejectWithValue("Página no válida");
      }
      const message =
        error.response?.data?.detail ||
        error.response?.data?.message ||
        "Error al obtener usuarios";

      return rejectWithValue(message);
    }
  },
);

export const createUserThunk = createAsyncThunk(
  "users/create",
  async (_, { getState, rejectWithValue }) => {
    try {
      const { usersForm } = getState();
      return await createUserService(usersForm.form);
    } catch (error) {
      const message =
        error.response?.data?.detail ||
        error.response?.data?.message ||
        "Error al crear usuario";

      return rejectWithValue(message);
    }
  },
);

export const getUserByIdThunk = createAsyncThunk(
  "users/getById",
  async (id, { rejectWithValue }) => {
    try {
      return await getUserByIdService(id);
    } catch (error) {
      const message =
        error.response?.data?.detail ||
        error.response?.data?.message ||
        "Error al obtener usuario";

      return rejectWithValue(message);
    }
  },
);

export const updateUserThunk = createAsyncThunk(
  "users/update",
  async ({ id, payload }, { rejectWithValue }) => {
    try {
      return await updateUserService(id, payload);
    } catch (error) {
      const message =
        error.response?.data?.detail ||
        error.response?.data?.message ||
        "Error al actualizar usuario";
      return rejectWithValue(message);
    }
  },
);

export const toggleUserActiveThunk = createAsyncThunk(
  "users/toggleActive",
  async ({ id, isActive }, { rejectWithValue }) => {
    try {
      return await toggleUserActiveService(id, isActive);
    } catch (error) {
      const message =
        error.response?.data?.detail ||
        error.response?.data?.message ||
        "Error al cambiar estado";

      return rejectWithValue(message);
    }
  },
);

export const getEscuelasThunk = createAsyncThunk(
  "users/getEscuelas",
  async (_, { rejectWithValue }) => {
    try {
      return await getEscuelasSelectorService();
    } catch (error) {
      const message =
        error.response?.data?.detail || "Error al obtener escuelas";
      return rejectWithValue(message);
    }
  },
);

export const getPlantelesThunk = createAsyncThunk(
  "users/getPlanteles",
  async (escuelaId, { rejectWithValue }) => {
    try {
      return await getPlantelesByEscuelaService(escuelaId);
    } catch (error) {
      const message =
        error.response?.data?.detail || "Error al obtener planteles";
      return rejectWithValue(message);
    }
  },
);
